import { color, Common } from '@stockbit/ui';
import Image from 'global/Image';
import styled from 'styled-components';

const { Text } = Common;

export const BlockedStateWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 60vh;
`;

export const Img = styled(Image)`
  margin-bottom: 32px;
`;

export const ContentWrapper = styled.div`
  text-align: center;

  ${Text} {
    text-align: center;
  }
`;

export const BlockedDesc = styled(Text)`
  max-width: 369px;
  color: ${color.highgray};
`;
